exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pastille{flex:1;line-height:1.25rem;font-size:18px;font-size:1.125rem}.pastille:before{content:\"\";display:block;padding-top:100%}@media (min-width:768px){.pastille{font-size:21px;font-size:1.3125rem}}", ""]);

